import FotoPerfil from './FotoUsuario.componente';

export default FotoPerfil;
